import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Dialog,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    Box
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { PersonOutline, RestaurantMenu, TrendingUp } from '@mui/icons-material';

const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-paper': {
        borderRadius: '24px',
        padding: theme.spacing(2),
        maxWidth: '480px',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    }
}));

const FeatureItem = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(1.5),
    backgroundColor: 'rgba(255, 255, 255, 0.15)',
    borderRadius: '12px',
    marginBottom: theme.spacing(1.5),
}));

const OnboardingPromptModal = ({ open, onClose }) => {
    const navigate = useNavigate();

    const handleStartOnboarding = () => {
        onClose();
        navigate('/onboarding');
    };

    return (
        <StyledDialog open={open} onClose={onClose}>
            <DialogContent sx={{ textAlign: 'center', py: 4 }}>
                {/* Welcome Icon */}
                <Box
                    sx={{
                        width: 80,
                        height: 80,
                        borderRadius: '50%',
                        bgcolor: 'rgba(255, 255, 255, 0.2)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto',
                        mb: 3,
                    }}
                >
                    <RestaurantMenu sx={{ fontSize: 40, color: '#fff' }} />
                </Box>

                <Typography variant="h4" sx={{ color: '#fff', fontWeight: 700, mb: 1 }}>
                    ¡Bienvenido a Nutrizia!
                </Typography>

                <Typography variant="body1" sx={{ color: 'rgba(255, 255, 255, 0.9)', mb: 4 }}>
                    Personaliza tu experiencia para obtener recomendaciones adaptadas a tus objetivos
                </Typography>

                {/* Features */}
                <Box sx={{ textAlign: 'left', mb: 3 }}>
                    <FeatureItem>
                        <PersonOutline sx={{ color: '#fff', fontSize: 28 }} />
                        <Box>
                            <Typography variant="subtitle2" sx={{ color: '#fff', fontWeight: 600 }}>
                                Perfil personalizado
                            </Typography>
                            <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                                Calcula tus macros según tu objetivo
                            </Typography>
                        </Box>
                    </FeatureItem>

                    <FeatureItem>
                        <RestaurantMenu sx={{ color: '#fff', fontSize: 28 }} />
                        <Box>
                            <Typography variant="subtitle2" sx={{ color: '#fff', fontWeight: 600 }}>
                                Menús inteligentes
                            </Typography>
                            <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                                Recetas adaptadas a tus preferencias
                            </Typography>
                        </Box>
                    </FeatureItem>

                    <FeatureItem>
                        <TrendingUp sx={{ color: '#fff', fontSize: 28 }} />
                        <Box>
                            <Typography variant="subtitle2" sx={{ color: '#fff', fontWeight: 600 }}>
                                Seguimiento de progreso
                            </Typography>
                            <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                                Controla tu evolución con métricas personalizadas
                            </Typography>
                        </Box>
                    </FeatureItem>
                </Box>
            </DialogContent>

            <DialogActions sx={{ flexDirection: 'column', gap: 1.5, px: 3, pb: 3 }}>
                <Button
                    fullWidth
                    variant="contained"
                    onClick={handleStartOnboarding}
                    sx={{
                        bgcolor: '#fff',
                        color: '#667eea',
                        borderRadius: '16px',
                        py: 1.5,
                        textTransform: 'none',
                        fontWeight: 700,
                        fontSize: '1rem',
                        '&:hover': {
                            bgcolor: 'rgba(255, 255, 255, 0.9)',
                        }
                    }}
                >
                    Personalizar mi experiencia
                </Button>

                <Button
                    fullWidth
                    onClick={onClose}
                    sx={{
                        color: 'rgba(255, 255, 255, 0.8)',
                        textTransform: 'none',
                        fontWeight: 500,
                        '&:hover': {
                            bgcolor: 'rgba(255, 255, 255, 0.1)',
                        }
                    }}
                >
                    Más tarde
                </Button>
            </DialogActions>
        </StyledDialog>
    );
};

export default OnboardingPromptModal;
